import React from 'react';

import Buttonlet from 'components/Buttonlet';

export default function ContactsHeader() {
  return (
    <div style={{ alignItems: 'center', display: 'flex ', marginBottom: '.5rem' }}>
      <h2 className="heading heading--2 heading--no-margin-bottom">
        Contacts
      </h2>
      {' '}
      <div style={{ marginLeft: '.5rem ' }}>
        <Buttonlet
          type="question"
          title="You can invite contacts to participate in stories with you. Add someone to your contacts list by entering their username. If they invite you to something, they'll be automatically added to your list."
        />
      </div>
    </div>

  );
}

ContactsHeader.displayName = 'ContactsHeader';
